import { createFileRoute } from '@tanstack/react-router';
import { QuotesPage } from '@/features/finance';

export const Route = createFileRoute('/_auth/o/$orgId/finance/quotes/')({
  component: QuotesRoute,
});

function QuotesRoute() {
  const { orgId } = Route.useParams();
  return <QuotesPage orgId={orgId} />;
}
